import "../styles/Loader.css"

const Loader = () => {
    return (
    <div className="loader" id="loader-fou"><img alt="Loading" src={require('../assets/fou.gif')} /></div>
  )
}

export default Loader